import {useMutation} from '@apollo/react-hooks';

import type {
    UpdatePeopleIqPreference as UpdatePeopleIqPreferenceMutation,
    UpdatePeopleIqPreferenceVariables as UpdatePeopleIqPreferenceMutationVariables,
    PeopleIqPreferenceInput,
} from 'nutshell-graphql-types';

import UPDATE_PREFERENCE from '../mutations/update-people-iq-preference.graphql';

export function useUpdatePeopleIqPreference(): {
    updatePeopleIqPreference: (arg1: PeopleIqPreferenceInput) => Promise<any>;
} {
    const [updatePeopleIqPreference] = useMutation<
        UpdatePeopleIqPreferenceMutation,
        UpdatePeopleIqPreferenceMutationVariables
    >(UPDATE_PREFERENCE);

    return {
        updatePeopleIqPreference: (input: PeopleIqPreferenceInput) =>
            updatePeopleIqPreference({
                variables: {input},
            }),
    };
}
